import { RESIDENT_LIST_SESSION_KEY } from '../constants/residentConstants'
import type { ResidentListQuery } from '../types'

export function readResidentListSessionFilter(): Partial<ResidentListQuery> {
  try {
    const raw = sessionStorage.getItem(RESIDENT_LIST_SESSION_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

export function writeResidentListSessionFilter(query: Partial<ResidentListQuery>): void {
  try {
    sessionStorage.setItem(RESIDENT_LIST_SESSION_KEY, JSON.stringify(query))
  } catch {
    /* Session persistence is best-effort, matching Angular's non-critical filter storage. */
  }
}

export function clearResidentListSessionFilter(): void {
  try {
    sessionStorage.removeItem(RESIDENT_LIST_SESSION_KEY)
  } catch {
    /* noop */
  }
}
